import { render } from "./WeddingCard.vue?vue&type=template&id=68964109&scoped=true"
import script from "./WeddingCard.vue?vue&type=script&lang=js"
export * from "./WeddingCard.vue?vue&type=script&lang=js"

import "./WeddingCard.vue?vue&type=style&index=0&id=68964109&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68964109"]])

export default __exports__